import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CameraService } from 'src/app/services/camera/camera.service';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-camera-counter-alert',
  templateUrl: './camera-counter-alert.component.html',
  styleUrls: ['./camera-counter-alert.component.css']
})
export class CameraCounterAlertComponent implements OnInit {
  reportForm: FormGroup;
  listCameras = [];
  listCameraRegions = [];
  regionSelect = 0;
  cameraSelect = 0;
  cameraIotHub = "";
  ShiftSelect = 0;
  itemCameraCounterSelect = 0;
  enterpriseSelect: number = 0;
  headquarterSelect = 0;
  starCounter = false;
  counter = 0;
  timeCounter = "";
  interval:any;
  image:string;
  showCameraCounter = false;
  listShift = [];
  listItemCameraCounter = [];
  lastTime: string;
  disabledInputs = false;

  constructor(private formBuilder: FormBuilder,
    private cameraService: CameraService,
    private changeDetector: ChangeDetectorRef,
    private enterpriseService: EnterpriseService,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,) {
    document.getElementById("titleHeaderNav").innerHTML = 'Video Analítica > <span class="font-weight-bold">Alertas de Cámaras de Conteo</span>';
  }

  ngOnInit() {
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.headquarterSelect = (+localStorage.getItem(AppConstants.Session.HEADQUARTER));
    this.createForm();
    this.getListCameras();
    this.getItemCounters();

    var _this = this;
    const connection = new signalR.HubConnectionBuilder()
    .withUrl(environment.fnVA + '/api')
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

    connection.on('updateCameraCounter', (data) => {
      //console.log("data update camera counter",data);
      if(data != null){
        if(data.id_Camera == _this.cameraSelect && data.id_Region == _this.regionSelect ){
          _this.image = data.c_PathImage + "?"+new Date();
          _this.counter = data.count;
          _this.lastTime = this.formatDateBeauty(new Date(data.AuditInsertDate));
          if(data.id_State == 3){
            clearInterval(_this.interval);
            _this.starCounter = false;
          }
          _this.changeDetector.detectChanges();
        }
      }
    });

    connection.start()
      .catch(console.error);
  }

  createForm() {
    this.reportForm = this.formBuilder.group({
        idCamera: [0, [Validators.required]],
        idRegion: [Validators.required],
        qtyUser:[0,Validators.required] ,
        idItem: [Validators.required],
        idShift: [Validators.required],
    });
  }

  getItemCounters(){
    this.spinner.show();
    this.cameraService.getItemCameraCounter(this.enterpriseSelect,this.headquarterSelect).subscribe((response => {
      console.log("items ",response);
      this.listItemCameraCounter = response.data;
      this.spinner.hide();
    }),
    (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getShifts(){
    this.spinner.show();
    this.enterpriseService.getListShifts(this.enterpriseSelect,this.headquarterSelect).subscribe((response => {
      this.listShift = response.data;
      this.validateExistCounter();
      this.spinner.hide();
    }),
    (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  get f() { return this.reportForm.controls; }

  starButton(){

    if(this.ShiftSelect == 0){
      this.alertService.showMessage("", "Debe seleccionar el turno", MessageSeverity.error);
      return false;
    }

    if(this.itemCameraCounterSelect == 0){
      this.alertService.showMessage("", "Debe seleccionar el item a contar", MessageSeverity.error);
      return false;
    }

    if(+this.reportForm.value["qtyUser"] < 1){
      this.alertService.showMessage("", "Debe indicar la cantidad de operarios", MessageSeverity.error);
      return false;
    }

    if(this.reportForm.valid){
        this.spinner.show();
        var data = {
          idUser: localStorage.getItem(AppConstants.Session.USERID),
          idCamera: this.cameraSelect,
          idRegion: this.regionSelect,
          userQty: +this.reportForm.value["qtyUser"],
          idCameraItemCounter: this.itemCameraCounterSelect,
          idShift: this.ShiftSelect,
          date: this.formatDate(new Date()),
          on: 1,
          nameIotHub: this.cameraIotHub
        };
        var _this = this;
        this.cameraService.updateCameraCounterStartStop(data).subscribe((response => {
          console.log(response);
          if(response.code == 200){
            _this.showCameraCounter = true;
            _this.starCounter = true;
            _this.counter = 0;
            _this.timeCounter = "";
            _this.startTimer();
            _this.disabledInputs = true;
          }
          this.spinner.hide();
        }),
        (error: HttpErrorResponse) => {
          this.spinner.hide();
        });
      }else{
        this.reportForm.markAllAsTouched();
      }
 }

 startTimer(){
    var _this = this;
    this.interval = setInterval(function () {
      var fecha = new Date(),
      hora = fecha.getHours(),
      minutos = fecha.getMinutes(),
      segundos = fecha.getSeconds(),
      diaSemana = fecha.getDay(),
      dia = fecha.getDate(),
      mes = fecha.getMonth(),
      anio = fecha.getFullYear();
      var d = dia.toString();
      if(dia<10){ d = "0"+dia.toString(); }
      var mo = mes.toString();
      if(mes<10){ mo = "0"+mes.toString(); }
      var h = hora.toString();
      if(hora<10){ h = "0"+hora.toString(); }
      var m = minutos.toString();
      if(minutos<10){ m = "0"+minutos.toString(); }
      var s = segundos.toString();
      if(segundos<10){ s = "0"+segundos.toString(); }

      _this.timeCounter = d+"/01/"+  anio+" " + h +":"+m+":"+s;

    }, 1000);
 }

 formatDate(date) {
  var hours = date.getHours();
  var month = (date.getMonth()+1);
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var day = date.getDate();
  var ampm = hours >= 12 ? 'pm' : 'am';
  minutes = minutes < 10 ? '0'+minutes : minutes;
  month = month < 10 ? '0'+month : month;
  day = day < 10 ? '0'+day : day;
  hours = hours < 10 ? '0'+hours : hours;
  seconds = seconds < 10 ? '0'+seconds : seconds;
  var strTime = hours + ':' + minutes + ':' + seconds;
  return date.getFullYear() + "-" + month + "-" + day + " " + strTime;
}

formatDateBeauty(date) {
  var hours = date.getHours();
  var month = (date.getMonth()+1);
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var day = date.getDate();
  var ampm = hours >= 12 ? 'pm' : 'am';
  minutes = minutes < 10 ? '0'+minutes : minutes;
  month = month < 10 ? '0'+month : month;
  day = day < 10 ? '0'+day : day;
  hours = hours < 10 ? '0'+hours : hours;
  seconds = seconds < 10 ? '0'+seconds : seconds;
  var strTime = hours + ':' + minutes + ':' + seconds;
  return day + "/" + month + "/"  + date.getFullYear() + " " + strTime;
}

  random(min, max) {
    return Math.floor((Math.random() * (max - min + 1)) + min);
  }

  stopButton(){
    this.starCounter = false;
    clearInterval(this.interval);
    if(this.reportForm.valid){
      this.spinner.show();
      var data = {
        idUser: localStorage.getItem(AppConstants.Session.USERID),
        idCamera: this.cameraSelect,
        idRegion: this.regionSelect,
        userQty: +this.reportForm.value["qtyUser"],
        idCameraItemCounter: this.itemCameraCounterSelect,
        idShift: this.ShiftSelect,
        date: this.formatDate(new Date()),
        on: 0,
        nameIotHub: this.cameraIotHub
      };
      var _this = this;
      this.cameraService.updateCameraCounterStartStop(data).subscribe((response => {
        if(response.code == 200){
          this.disabledInputs = false;
          this.starCounter = false;
        }
        this.spinner.hide();
      }),
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
    }else{
      this.reportForm.markAllAsTouched();
    }
  }

  getListCameras(){
    this.spinner.show();
    this.cameraService.getListCameraCounters(this.enterpriseSelect,this.headquarterSelect).subscribe((response => {
      this.listCameras = response.data;
      if(this.listCameras.length > 0){
        this.cameraSelect = this.listCameras[0].id;
        this.cameraIotHub = this.listCameras[0].nameIotHub;
        var d = {
          value:  this.cameraSelect
        }
        this.getListCameraRegions(d);
      }
      this.spinner.hide();
    }),
    (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getListCameraRegions(data){
    this.spinner.show();
    this.cameraSelect = data.value;
    this.cameraService.getListRegionsCameraCounter(data.value).subscribe((response => {
      this.listCameraRegions = response.data;
      this.cameraIotHub = this.listCameras.filter(x => x.id == data.value)[0].nameIotHub;
      if(this.listCameraRegions.length > 0){
        this.regionSelect = this.listCameraRegions[0].id;
      }
      this.getShifts();
      this.spinner.hide();
    }),
    (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  validateExistCounter(){
    if(this.regionSelect > 0 && this.cameraSelect > 0){
      this.spinner.show();
      this.cameraService.getCameraCounterRegionById(this.cameraSelect,this.regionSelect).subscribe((response => {
        var data = response.data;
        if(data != null){
          this.counter = data.count;
          this.image = data.image;
          this.reportForm.controls['qtyUser'].setValue(data.userQty);
          this.itemCameraCounterSelect = data.idCameraItemCounter;
          this.ShiftSelect = data.idShift;
          this.reportForm.controls['idShift'].setValue(data.idShift);
          this.showCameraCounter = true;
          if(data.updateAtImageCounter){
            this.lastTime = this.formatDateBeauty(new Date(data.updateAtImageCounter));
          }
          if(data.idState == 2 || data.idState == 1){
            this.starCounter = true;
          }
          this.startTimer();
          this.disabledInputs = true;
        }else{
          this.disabledInputs = false;
          this.showCameraCounter = false;
          this.counter = 0;
          this.starCounter = false;
          this.lastTime = "";
          if(this.interval != null){
            clearInterval(this.interval);
          }
          this.timeCounter = "";
        }
        this.spinner.hide();
      }),
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.disabledInputs = false;
      });
    }
  }

  changeRegion(e){
    this.regionSelect = e.value;
    this.disabledInputs = false;
    this.reportForm.controls['qtyUser'].setValue(0);
    this.reportForm.controls['idItem'].setValue(0);
    this.itemCameraCounterSelect = 0;
    this.validateExistCounter();
    this.ShiftSelect = 0;
  }

  changeShift(e){
    this.ShiftSelect = e.value;
    this.validateExistCounter();
  }
}
